// Centralized API base URL for frontend
// Priority:
// 1. REACT_APP_API_BASE_URL environment variable (set in Vercel/production)
// 2. Production domain (vercel deployed app)
// 3. Local development with dynamic hostname
// 4. Fallback to localhost

const getApiBaseUrl = () => {
  // 1. Use environment variable if explicitly set (Vercel production)
  if (process.env.REACT_APP_API_BASE_URL) {
    console.log('📡 Using REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // 2. Check if running on production domain
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    
    // If on production domain (not localhost or IP), use Render backend
    if (!hostname.includes('localhost') && !hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
      const prodUrl = `https://macronix-backend.onrender.com/api`;
      console.log('📡 Using production API URL:', prodUrl);
      return prodUrl;
    }
    
    // 3. For local development, construct URL from current hostname
    const localUrl = `${protocol}//${hostname}:5000/api`;
    console.log('📡 Using local API URL:', localUrl);
    return localUrl;
  }
  
  // 4. Fallback for build-time usage (e.g., SSR)
  console.log('📡 Using fallback API URL: http://localhost:5000/api');
  return 'http://localhost:5000/api';
};

const API_BASE_URL = getApiBaseUrl();

// The uploads are served at /uploads from the backend root
// Derive uploads base by replacing trailing /api when present
const ROOT_BASE_URL = API_BASE_URL.replace(/\/api$/, '');
export const UPLOADS_BASE_URL = `${ROOT_BASE_URL}/uploads/fo`;
export default API_BASE_URL;
